var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebsiteCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.676 5.34a6 6 0 0 0 6.613 9.708c.086-.563-.103-1.103-.18-1.292-.172-.42-.741-1.138-1.69-2.133-.253-.266-.237-.47-.146-1.077l.01-.069c.061-.415.165-.661 1.564-.883.71-.113.897.17 1.156.565l.087.128c.246.36.428.443.704.567.123.057.277.128.483.244.49.28.49.596.49 1.287v.079c0 .293-.03.551-.074.775a6 6 0 0 0-2.329-9.255c-.415.28-.984.676-1.183.949-.101.138-.245.849-.712.907a2.75 2.75 0 0 1-.46-.007c-.466-.03-1.104-.071-1.308.483-.13.351-.152 1.305.267 1.8.068.079.08.225.034.39a.76.76 0 0 1-.219.373c-.072-.042-.216-.21-.314-.322-.235-.274-.529-.616-.908-.72-.138-.039-.29-.07-.437-.102-.412-.086-.878-.184-.986-.415-.08-.17-.08-.403-.08-.649 0-.313 0-.666-.152-1.009a.957.957 0 0 0-.23-.322ZM9 17A7.5 7.5 0 1 1 9 2a7.5 7.5 0 0 1 0 15Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteCopy);
export default __webpack_public_path__ + "static/media/website-copy.9d080e40.svg";
export { ForwardRef as ReactComponent };